import { render, staticRenderFns } from "./xxzxBanKuai.vue?vue&type=template&id=75a7b2d1&scoped=true"
import script from "./xxzxBanKuai.vue?vue&type=script&lang=js"
export * from "./xxzxBanKuai.vue?vue&type=script&lang=js"
import style0 from "./xxzxBanKuai.vue?vue&type=style&index=0&id=75a7b2d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a7b2d1",
  null
  
)

export default component.exports